import { styled } from "goober";

export const ArticleListContainer = styled("ol")`
  & {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    row-gap: var(--sp-8);

    @container (inline-size <= 800px) {
      row-gap: var(--sp-4);
    }
  }

  .article-link {
    position: relative;
    padding: var(--sp-2);
    padding-block-end: 1rem;
    border-radius: var(--br-xl);

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: var(--br-xl);
      background: var(--shade4-15);
      z-index: -1;
      scale: 0.9;
      opacity: 0;
      backdrop-filter: blur(10px);
      transition:
        scale var(--transition),
        opacity var(--transition);
    }

    &:hover {
      &::before {
        scale: 1;
        opacity: 1;
      }
      .article-title {
        color: var(--game-accent-color);
      }
    }
  }

  .article-list-item {
    position: relative;
    display: grid;
    gap: var(--sp-3);

    svg {
      position: absolute;
      top: var(--sp-2);
      left: var(--sp-2);
      width: var(--sp-5);
      height: var(--sp-5);
      border-radius: var(--br);
      background: var(--game-accent-color);

      path {
        fill: var(--shade10);
      }
    }
  }
  .article-meta {
    display: grid;
    gap: var(--sp-1);
    padding-inline: var(--sp-3);
  }
  .article-image {
    width: 100%;
    height: auto;
    aspect-ratio: 120 / 63;
    object-fit: cover;
    border-radius: var(--br-lg);
    background: var(--shade7);
    transition: scale var(--transition);
  }
  .article-title {
    font-size: 1.125rem;
    font-weight: 700;
    color: var(--shade0);
    line-height: 1.25;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    transition: color var(--transition);
  }
  .article-excerpt {
    color: var(--shade1);
    font-size: 0.875rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .article-text-loading {
    height: 1rem;
    width: 100%;
    background: var(--shade7);
    border-radius: var(--br-sm);
  }
`;
